import { render } from "./NotificationsPopups.vue?vue&type=template&id=c6cb45f4"
import script from "./NotificationsPopups.vue?vue&type=script&lang=js"
export * from "./NotificationsPopups.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__